import React from "react"
import CreatableDropDown from "../../../../components/CreatableDropDown"
import { Mutation, Query } from "react-apollo"
import CREATE_FAVORITES_FOLDER from "../../../../graphql/createFavoritesFolder.graphql"
import gql from "graphql-tag"
import { REMOVE_FROM_FOLDER_OPTION } from "../../constants"

import "./style.scss"

const FolderSelect = (props) => {
  const { data, currentFolderId } = props

  // sort folders alphabetically.
  let sortedFolder = data.viewer.folders.sort((a, b) =>
    a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1
  )

  // filter out the current folder if you're in the folder view.
  if (currentFolderId) {
    sortedFolder = sortedFolder.filter(
      (folder) => folder.id !== currentFolderId
    )
  }

  // map the folders to react select options.
  let options = sortedFolder.map((folder) => ({
    label: folder.name,
    value: folder.id,
  }))

  if (currentFolderId)
    options.unshift({ label: REMOVE_FROM_FOLDER_OPTION, value: "" })

  const handleChange = (e) => {
    if (e && e.label) {
      props.setFolderName(e.label)
      props.setFolderId(e.value)
    } else {
      props.setFolderName("")
      props.setFolderId("")
    }
  }

  const handleCreate = async (label, mutate) => {
    let result = await mutate({
      variables: {
        name: label,
      },
    })
    props.refetch()
    const newOption = {
      label,
      value: result.data.createFavoritesFolder.id,
    }
    props.setFolderName(newOption.label)
    props.setFolderId(newOption.value)
  }

  return (
    <Mutation mutation={CREATE_FAVORITES_FOLDER}>
      {(mutate) => (
        <CreatableDropDown
          placeholder={props.placeholder}
          onChange={handleChange}
          onCreateOption={(e) => handleCreate(e, mutate)}
          options={options}
          label={props.folderName}
          value={props.folderId}
          style={"react-select-container"}
        />
      )}
    </Mutation>
  )
}

const getFolders = gql`
  query getViewerFolders {
    viewer {
      id
      folders {
        id
        name
      }
    }
  }
`

const FolderSelectWithData = (props) => {
  return (
    <Query query={getFolders}>
      {({ loading, error, data, refetch }) => {
        if (loading || error) return null
        return <FolderSelect data={data} refetch={refetch} {...props} />
      }}
    </Query>
  )
}

export default FolderSelectWithData
